module.exports = __webpack_public_path__ + "static/media/yin-yang.581bcafd.svg";